import { isRouteErrorResponse } from "react-router-dom";

export interface RouteErrorDetails {
  isNotFound: boolean;
  title: string;
  message: string;
  code: string | number;
}

export const getRouteErrorDetails = (
  error: unknown,
  pathname: string,
): RouteErrorDetails => {
  let isNotFound = !error;
  let title = "Page Not Found";
  let message = `The page "${pathname}" does not exist.`;
  let code: string | number = 404;

  if (isRouteErrorResponse(error)) {
    code = error.status;
    title = error.statusText;
    message = error.data?.message || "Sorry, an unexpected error has occurred.";

    if (error.status === 404) {
      title = "Page Not Found";
      message = "We couldn't find the page you're looking for.";
      isNotFound = true;
    } else {
      isNotFound = false;
    }
  } else if (error instanceof Error) {
    code = 500;
    title = "Application Error";
    message = error.message;
    isNotFound = false;
  } else if (error) {
    code = "Unknown";
    title = "Something went wrong";
    message = String(error);
    isNotFound = false;
  }

  return { isNotFound, title, message, code };
};
